"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var group_1 = require("../context/group");
var Helper_1 = __importDefault(require("./Base/Helper"));
var Base_1 = __importDefault(require("./Base"));
var Circle = /** @class */ (function (_super) {
    __extends(Circle, _super);
    function Circle(props) {
        var _this = _super.call(this, props) || this;
        _this.helper = new Helper_1.default('circle');
        return _this;
    }
    return Circle;
}(Base_1.default));
exports.default = (0, group_1.withGroupContext)(Circle);
//# sourceMappingURL=Circle.js.map